export const purchaseFieldSx = {
  backgroundColor: '#222',
  borderRadius: '8px',
  color: '#fff',
};

export const purchaseDialogPaperProps = {
  sx: {
    borderRadius: 10,
    overflow: 'auto',
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
};

export const purchaseDialogInnerSx = {
  border: '1px solid #7B1FA2',
  borderRadius: 10,
  overflow: 'auto',
};

export const purchaseDialogTitleSx = {
  fontSize: '22px',
  fontWeight: 'bold',
  color: '#fff',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: '#181818',
  padding: '16px',
};

export const purchaseDialogContentSx = {
  backgroundColor: '#181818',
  padding: '24px',
};

export const purchaseDialogActionsSx = {
  backgroundColor: '#181818',
  padding: '16px',
};

export const purchaseSectionCardSx = {
  borderRadius: 2,
  height: '100%',
  backgroundColor: '#1e1e1e',
  boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
};
